import { scrollLeftToShow, type TrackViewport } from '../helpers/timelineZoom';

/** Programmatic scrolls move smoothly unless the reader asks for less motion. */
export function scrollBehavior(): ScrollBehavior {
    const reduce =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    return reduce ? 'auto' : 'smooth';
}

/** A page is most of the visible track, so a little of the last one stays in view. */
const PAGE_SHARE = 0.9;

/**
 * Where a key sends the focused timeline: Home to the cycle's start, End to today (or the
 * axis end when today is off it), Page Up and Page Down by most of a view. Null for any other
 * key, which the browser handles (the arrow keys scroll by a step).
 */
export function timelineKeyTarget(
    key: string,
    scrollLeft: number,
    todayPct: number | null
): ((geometry: TrackViewport) => number) | null {
    switch (key) {
        case 'Home':
            return () => 0;
        case 'End':
            return (geometry) =>
                todayPct === null ? geometry.maxScroll : scrollLeftToShow(todayPct, geometry);
        case 'PageDown':
            return (geometry) =>
                Math.min(geometry.maxScroll, scrollLeft + geometry.viewPx * PAGE_SHARE);
        case 'PageUp':
            return (geometry) => Math.max(0, scrollLeft - geometry.viewPx * PAGE_SHARE);
        default:
            return null;
    }
}
